document.addEventListener("DOMContentLoaded", () => {
	document.querySelector(".popupButton").addEventListener("click", () => {
		document.getElementById("overlay").style.display = "flex";
	});

	document
		.querySelector(".close-popup-button")
		.addEventListener("click", () => {
			document.getElementById("overlay").style.display = "none";
		});

	console.log("script loaded");
});
